























import { Component, Vue, Prop } from 'vue-property-decorator';
import ProductGroupShow from '@/components/ProductGroup/ProductGroupShow.vue';
import { GQL_productGroup_productGroup } from '@/queries/__generated__/productGroup';

@Component({
  components: {
    ProductGroupShow,
  },
})
export default class ProductGroupShowButton extends Vue {
  @Prop() private productGroup!: GQL_productGroup_productGroup;
  private showDialog = false;
}
